import { useMemo } from 'react';
import { SchedulerHeartAndLungsSurgeons } from '@lp/features/Scheduler';
import { useAuthContext } from '@lp/core/auth';
import { SchedulerPermissions } from '@/permissions';
import { OrganType } from '@/api/apis/case';

export const SHtLuSchedule = () => {
  const { employeeData, checkPermission } = useAuthContext();
  const showSettings = checkPermission(SchedulerPermissions.SSchedulesSettingsWrite);

  const hasSScheduleWritePermission = useMemo(() => {
    const hasWritePermissions = checkPermission(SchedulerPermissions.SSchedulesWrite);
    const hasSHtLuWritePermissions = checkPermission(SchedulerPermissions.SHtLuSchedulesWrite);

    const canEditSHtLuSchedule =
      hasSHtLuWritePermissions &&
      employeeData?.employee?.rsScheduleManagerOrgans.some(
        (organ) => organ === OrganType.Heart || organ === OrganType.Lungs,
      );

    return hasWritePermissions || canEditSHtLuSchedule;
  }, [checkPermission, employeeData?.employee.rsScheduleManagerOrgans]);

  return <SchedulerHeartAndLungsSurgeons readonly={!hasSScheduleWritePermission} showSettings={showSettings} />;
};
